// Sometimes a form has only optional fields. This function checks if at least one of the fields
// was filled out so we don't render an empty summary block for it
const optionalFormContainsData = (formData)=>formData && Object.values(formData).some((value)=>!!value
    )
;

export { optionalFormContainsData };
//# sourceMappingURL=optional-form-contains-data.js.map
